import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { setStep } from "@app/store/reducers/studentCount";
import DualPaneBuilder from "./DualPaneBuilder";
import SetPreferences from "./SetPreferences";
import { clearPathwayStore } from "@app/store/reducers/learningPathway";

const LearningPathwayWrapper = () => {

    const lpStore = useSelector((state: any) => state.learningPathway);
    const dispatch = useDispatch();

	useEffect(() => {
		return () => {
			dispatch(setStep(1));
			dispatch(clearPathwayStore())
		};
	}, []);

	return (
		<>
		<section className="modul_sec_wrapper">
			<div className="col-md-12">
				<div className="card card-primary mb-0">
					<div className="card-header header">
						<h3 className="card-title">{ lpStore.step === 1 ? 'Step I - Set Preferences' : (lpStore.step === 2 ? 'Step II - Learning Pathway Builder' : 'Error')}</h3>
						{/* { lpStore.step !== 1 && (
							<div className="card-tools">
								<h3 className="card-title">Pathway Name : {lpStore?.name} | Subject : {lpStore?.name}</h3>
							</div>
						)} */}
					</div>
				</div>
			</div>
			{ lpStore.step == 1 && (
				<SetPreferences/>
			)}
			{ lpStore.step == 2 && (
				<DualPaneBuilder/>
			)}
			
		</section>
		</>
	);
};

export default LearningPathwayWrapper;